export type DuplicateArtifactKind = "rawFiles" | "fastaFiles" | "libraryFiles" | "archiveFiles" | "softwareSettings" | "conditionSetup" | "modificationRepository" | "reportSettings" | "goFiles";

export interface DuplicateJobMetadata {
  jobId: string;
  sourceJobId: string;
  sourceJobName: string;
  sourceAnalysisName?: string | null;
  sourceCreatedAt?: string | null;
  sourceSoftwareVersion?: string | null;
  duplicatedAt: string;
  restartFromStepId?: string | null;
  reusedArtifacts: Partial<Record<DuplicateArtifactKind, string[]>>;
}

const DUPLICATE_JOB_METADATA_STORAGE_KEY = "duplicate-job-metadata";

const readDuplicateJobMetadataMap = (): Record<string, DuplicateJobMetadata> => {
  try {
    const rawValue = localStorage.getItem(DUPLICATE_JOB_METADATA_STORAGE_KEY);
    if (!rawValue) return {};

    const parsed = JSON.parse(rawValue) as Record<string, DuplicateJobMetadata>;
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
};

const writeDuplicateJobMetadataMap = (metadataMap: Record<string, DuplicateJobMetadata>) => {
  localStorage.setItem(DUPLICATE_JOB_METADATA_STORAGE_KEY, JSON.stringify(metadataMap));
};

export const saveDuplicateJobMetadata = (metadata: DuplicateJobMetadata) => {
  const metadataMap = readDuplicateJobMetadataMap();
  metadataMap[metadata.jobId] = metadata;
  writeDuplicateJobMetadataMap(metadataMap);
};

export const getDuplicateJobMetadata = (jobId: string): DuplicateJobMetadata | null => {
  const metadataMap = readDuplicateJobMetadataMap();
  return metadataMap[jobId] ?? null;
};

export const getDuplicateJobMetadataMap = (): Record<string, DuplicateJobMetadata> => readDuplicateJobMetadataMap();
